module.exports = __webpack_public_path__ + "static/media/6973.121e77e8.jpg";